import styled from "styled-components"

import thermostatImg from "assets/img/referral-thermostat.png"
import { ReactComponent as IconCheck } from "assets/svg/icon-check.svg"

import { GIFT_FEATURES } from "./content"
import { displayFont, Eyebrow, gradientText, mobileBreakpoint, tabletBreakpoint } from "./shared"

const GiftSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 64px;
  padding: 80px 24px;
  background: #000;
  color: #fff;

  @media only screen and (width <= ${tabletBreakpoint}) {
    flex-direction: column;
    gap: 40px;
  }
`

const GiftImage = styled.div`
  flex-shrink: 0;

  img {
    width: 380px;
    max-width: 100%;
  }

  @media only screen and (width <= ${mobileBreakpoint}) {
    img {
      width: 280px;
    }
  }
`

const GiftContent = styled.div`
  max-width: 525px;

  h2 {
    font-family: ${displayFont};
    font-size: 44px;
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: -1.5px;

    @media only screen and (width <= ${mobileBreakpoint}) {
      font-size: 32px;
      letter-spacing: -1px;
    }
  }
`

const GradientHeading = styled.span`
  ${gradientText}
`

const GiftText = styled.p`
  margin: 16px 0 28px;
  color: rgb(255 255 255 / 72%);
  font-size: 1rem;
  line-height: 1.65;
`

const GiftFeatures = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    gap: 14px;
  }

  h3 {
    font-size: 1rem;
    font-weight: 600;
    line-height: 24px;
  }

  p {
    margin: 6px 0 0;
    color: rgb(255 255 255 / 66%);
    font-size: 0.875rem;
    line-height: 1.5;
  }
`

const CheckIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgb(122 220 232 / 16%);

  svg {
    width: 14px;
    height: 14px;

    path {
      stroke: #7adce8;
    }
  }
`

export const Gift = () => (
  <GiftSection>
    <GiftImage>
      <img src={thermostatImg} alt="Nuve smart thermostat" />
    </GiftImage>
    <GiftContent>
      <Eyebrow $light>Your gift</Eyebrow>
      <h2>
        <GradientHeading>More than a thermostat.</GradientHeading>
        <br />A smart home from day one.
      </h2>
      <GiftText>
        A premium ENERGY STAR smart thermostat, professionally installed and paired to your phone — nothing to buy,
        nothing to set up.
      </GiftText>
      <GiftFeatures>
        {GIFT_FEATURES.map(feature => (
          <li key={feature.title}>
            <CheckIcon aria-hidden>
              <IconCheck />
            </CheckIcon>
            <div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </div>
          </li>
        ))}
      </GiftFeatures>
    </GiftContent>
  </GiftSection>
)
